// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Playlist_outerMostdiv__nFlHL{
    background-color: #000;
}
.Playlist_outerHeading__xSa2- {
    display: flex;
    justify-content: center;
    align-items: center;
 }
.Playlist_Media_title__MKBui {
    color: #fff;
    font-size: 2.5rem;
    text-align: center;
    text-transform: uppercase;
    border-bottom: 2px solid #ff0000;
    padding-top: 4rem;
}`, "",{"version":3,"sources":["webpack://./src/demo/Playlist.module.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;CACtB;AACD;IACI,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,gCAAgC;IAChC,iBAAiB;AACrB","sourcesContent":[".outerMostdiv{\n    background-color: #000;\n}\n.outerHeading {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n }\n.Media_title {\n    color: #fff;\n    font-size: 2.5rem;\n    text-align: center;\n    text-transform: uppercase;\n    border-bottom: 2px solid #ff0000;\n    padding-top: 4rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"outerMostdiv": `Playlist_outerMostdiv__nFlHL`,
	"outerHeading": `Playlist_outerHeading__xSa2-`,
	"Media_title": `Playlist_Media_title__MKBui`
};
export default ___CSS_LOADER_EXPORT___;
